import { SalesSectionProps } from '.'

export const swapSectionData: SalesSectionProps = {
  headingText: 'Trade anything. No registration, no hassle.',
  bodyText: 'Trade any token on Binance Smart Chain in seconds, just by connecting your wallet.',
  reverse: false,
  primaryButton: {
    to: '/swap',
    text: 'Trade Now',
    external: false,
  },
  secondaryButton: {
    to: 'https://docs.pancakeswap.finance/',
    text: 'Learn',
    external: true,
  },
  images: {
    path: '/images/home/trade/',
    attributes: [
      { src: 'BNB', alt: 'BNB token' },
      { src: 'BTC', alt: 'BTC token' },
      { src: 'VIZSLASWAP', alt: 'VIZSLASWAP token' },
    ],
  },
}

export const earnSectionData: SalesSectionProps = {
  headingText: 'Earn passive income with crypto.',
  bodyText: 'VizslaSwap makes it easy to make your crypto work for you.',
  reverse: true,
  primaryButton: {
    to: '/farms',
    text: 'Explore',
    external: false,
  },
  secondaryButton: {
    to: 'https://docs.pancakeswap.finance/products/yield-farming',
    text: 'Learn',
    external: true,
  },
  images: {
    path: '/images/home/earn/',
    attributes: [
      { src: 'pie', alt: 'Pie chart' },
      { src: 'stonks', alt: 'Stocks chart' },
      { src: 'folder', alt: 'Folder with VIZSLASWAP token' },
    ],
  },
}

export const cakeSectionData: SalesSectionProps = {
  headingText: 'VIZSLASWAP is the loyal friend and heart of the #Hungarian Vizsla Inu ecosystem.',
  bodyText:
    'VizslaSwap is a decentralized exchange running on BNB Smart Chain with lots of features that let you trade and earn tokens.',
  reverse: false,
  primaryButton: {
    to: '/swap',
    text: 'Trade',
    external: false,
  },
  secondaryButton: {
    to: '/pools/all',
    text: 'Earn',
    external: false,
  },
  images: {
    path: '/images/home/cake/',
    attributes: [
      { src: 'bottom-right', alt: 'Small 3d VIZSLASWAP' },
      { src: 'top-right', alt: 'Small 3d VIZSLASWAP' },
      { src: 'coin', alt: 'VIZSLASWAP token' },
    ],
  },
}
